"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerInformationVisitorToJSON = exports.CustomerInformationVisitorFromJSONTyped = exports.CustomerInformationVisitorFromJSON = void 0;
var runtime_1 = require("../runtime");
function CustomerInformationVisitorFromJSON(json) {
    return CustomerInformationVisitorFromJSONTyped(json, false);
}
exports.CustomerInformationVisitorFromJSON = CustomerInformationVisitorFromJSON;
function CustomerInformationVisitorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'login': json['login'],
        'id': json['id'],
        'a': json['a'],
        'gen': json['gen'],
        'art': json['art'],
        'stat': json['stat'],
        'loc': json['loc'],
        'postco': json['postco'],
        'employee': json['employee'],
        'rataff': json['rataff'],
        'grp': json['grp'],
        'noret': json['noret'],
        'groaff': json['groaff'],
        'sortaff': json['sortaff'],
        'gutaff': json['gutaff'],
        'appu': json['appu'],
        'pk': !(0, runtime_1.exists)(json, 'pk') ? undefined : json['pk'],
        'createDate': !(0, runtime_1.exists)(json, 'createDate') ? undefined : (new Date(json['createDate'])),
        'markCC': !(0, runtime_1.exists)(json, 'markCC') ? undefined : json['markCC'],
        'cuid': !(0, runtime_1.exists)(json, 'cuid') ? undefined : json['cuid'],
    };
}
exports.CustomerInformationVisitorFromJSONTyped = CustomerInformationVisitorFromJSONTyped;
function CustomerInformationVisitorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'login': value.login,
        'id': value.id,
        'a': value.a,
        'gen': value.gen,
        'art': value.art,
        'stat': value.stat,
        'loc': value.loc,
        'postco': value.postco,
        'employee': value.employee,
        'rataff': value.rataff,
        'grp': value.grp,
        'noret': value.noret,
        'groaff': value.groaff,
        'sortaff': value.sortaff,
        'gutaff': value.gutaff,
        'appu': value.appu,
        'pk': value.pk,
        'createDate': value.createDate === undefined ? undefined : (value.createDate.toISOString().substr(0, 10)),
        'markCC': value.markCC,
        'cuid': value.cuid,
    };
}
exports.CustomerInformationVisitorToJSON = CustomerInformationVisitorToJSON;
//# sourceMappingURL=CustomerInformationVisitor.js.map